const initialState = {
  loading:false,
  error: null,
  data:[],
  schoolCareers:{
    loading:false,
    error:null,
    data:[],
  },
  unitUsersInfo:{
    loading:false,
    error:null,
    data:[],
  }
};
  
const academicReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_CARRERAS_REQUEST':
      return { ...state, loading :true  };
    case 'GET_ALL_CARRERAS_SUCCESS':
      return { ...state, loading: false, error:null, data:action.payload};
    case 'GET_ALL_CARRERAS_FAIL':
      return { ...state, loading: false, error: action.payload };
    case 'GET_ACADEMIC_USERS_POSITIONS_REQUEST':
      return {
        ...state,
        unitUsersInfo: { ...state.unitUsersInfo, loading: true, error: null },
      };
    case 'GET_ACADEMIC_USERS_POSITIONS_SUCCESS':
      return {
        ...state,
        unitUsersInfo: { ...state.unitUsersInfo, loading: false, error: null, data: action.payload },
      };
    case 'GET_ACADEMIC_USERS_POSITIONS_FAIL':
      return {
        ...state,
        unitUsersInfo: { ...state.unitUsersInfo, loading: false, error: action.payload },
      };
    case 'GET_ALL_FACULTADES_CARRERAS_REQUEST':
      return {
        ...state,
        schoolCareers: { ...state.schoolCareers, loading: true, error: null },
      };
    case 'GET_ALL_FACULTADES_CARRERAS_SUCCESS':
      return {
        ...state,
        schoolCareers: { ...state.schoolCareers, loading: false, error: null, data: action.payload },
      };
    case 'GET_ALL_FACULTADES_CARRERAS_FAIL':
      return {
        ...state,
        schoolCareers: { ...state.schoolCareers, loading: false, error: action.payload },
      };
    default:
      return state;
  }
};
  
export default academicReducer;
  